import { render } from "./moreChatwoot.vue?vue&type=template&id=ce4baa24"
import script from "./moreChatwoot.vue?vue&type=script&lang=js"
export * from "./moreChatwoot.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__